import React from 'react'
import { Chevron, ChevronDirection } from '@ui-lib/icons/chevron'
import cn from 'classnames'
import styles from './select.module.scss'

interface SelectProps {
  value: string
  options: string[]
  className?: string
  onChange: React.ChangeEventHandler<HTMLSelectElement>
}

export const Select: React.FC<SelectProps> = ({ value, options, className, onChange }) => {
  const selectOptions = options.map((option) => {
    if (option.includes(':')) {
      const [value, text] = option.split(':').map((part) => part.trim())
      return { value, text }
    }
    return { value: option, text: option }
  })

  return (
    <div className={cn(styles.selectWrapper, className)}>
      <select value={value} className={styles.select} onChange={onChange} autoComplete="off">
        <option value="" selected>
          Please select
        </option>

        {selectOptions.map(({ value, text }) => (
          <option value={value} key={value}>
            {text}
          </option>
        ))}
      </select>

      <Chevron direction={ChevronDirection.down} width="20" height="20" />
    </div>
  )
}
